import { Popover, PopoverContent, PopoverTrigger } from "@ui/shad/popover"
import { cn } from "@ui/utils"
import { MessageSquare } from "lucide-react"

import { CommentSection } from "./comment-section"

interface CommentPopoverProps {
  resourceType: "Household" | "Task" | "Opportunity"
  resourceId: string
  commentsCount?: number
}

export function CommentPopover({ resourceType, resourceId, commentsCount = 0 }: CommentPopoverProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          aria-label={`View ${commentsCount} ${commentsCount === 1 ? "comment" : "comments"}`}
          className={cn(
            "absolute top-1/2 right-0 flex items-center gap-1 rounded-sm p-1",
            "-translate-y-1/2",
            "bg-background hover:bg-muted outline-hidden",
            "transition-all duration-200 ease-in-out",
            resourceType !== "Task" && [
              "translate-x-full opacity-0",
              "group-hover:translate-x-0 group-hover:opacity-100",
              "group-focus-within:translate-x-0 group-focus-within:opacity-100 group-focus-within:outline-hidden",
              "data-[state=open]:translate-x-0 data-[state=open]:opacity-100",
            ]
          )}
        >
          <MessageSquare className={cn("text-icon/80", resourceType === "Task" ? "size-3.5" : "size-3")} />
          {commentsCount > 0 && <span className="text-muted-foreground text-xs">{commentsCount}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="flex max-h-[80vh] w-96 flex-col p-0"
        align="start"
        side="right"
        sideOffset={8}
        collisionPadding={16}
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <div className="flex flex-col overflow-hidden" onKeyDown={(e) => e.stopPropagation()}>
          <div className="flex-shrink-0 px-4 pt-4 pb-2">
            <h4 className="text-sm font-semibold">Comments</h4>
          </div>
          <div className="min-h-0 flex-1 overflow-y-auto px-4 pb-4">
            <CommentSection resourceType={resourceType} resourceId={resourceId} />
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}
